/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/


import APIManager from "../../ApiManager/ApiManager";
import {
    FETCH_BINARY_KEY_DETAILS_REQUEST,FETCH_BINARY_KEY_DETAILS_SUCCESS,FETCH_BINARY_KEY_DETAILS_FAILURE,FETCH_BINARY_KEY_DELETE_REQUEST,FETCH_BINARY_KEY_DELETE_SUCCESS,FETCH_BINARY_KEY_DELETE_FAILURE
   } from "./BinaryDetailsTypes";
import { COMMON_ERROR } from "../ApplicationDetailsError/ApplicationDetailsErrorTypes";

export const fetchBinaryKeyDetailsRequest = () => {
    return {
      type: FETCH_BINARY_KEY_DETAILS_REQUEST,
    };
  };
  
  export const fetchBinaryKeyDetailsSuccess = (bannerData) => {
    return {
      type: FETCH_BINARY_KEY_DETAILS_SUCCESS,
      payload: bannerData,
    };
  };
  
  export const fetchBinaryKeyDetailsFailure = (error) => {
    return {
      type: FETCH_BINARY_KEY_DETAILS_FAILURE,
      payload: error,
    };
  };

  export const fetchDeleteBinaryKeyRequest=()=>{
    return{
      type:FETCH_BINARY_KEY_DELETE_REQUEST
    }
  }

  export const fetchDeleteBinaryKeySuccess=()=>{
    return{
      type:FETCH_BINARY_KEY_DELETE_SUCCESS
    }
  }

  export const fetchDeleteBinaryKeyFailed=(error)=>{
    return{
      type:FETCH_BINARY_KEY_DELETE_FAILURE,
      payload:error
    }
  }
  
  export const fetchBinaryKeyDetails = (applicationId,submissionId,file) => {
    return async function (dispatch) {
      dispatch(fetchBinaryKeyDetailsRequest());
      try {
        const data = await APIManager.uploadSignedBinaryFile(applicationId, submissionId,file);
        dispatch(fetchBinaryKeyDetailsSuccess(data));
      } catch (error) {
        dispatch(fetchBinaryKeyDetailsFailure(error));
        dispatch(commonError(error, FETCH_BINARY_KEY_DETAILS_FAILURE));
      }
     };
  };
  export const fetchDeleteBinaryKeyDetails =(applicationId,submissionId,binaryKey)=>{
    return async function (dispatch) {
        dispatch(fetchDeleteBinaryKeyRequest());
        try {
          await APIManager.deleteBinaryDetaila(applicationId, submissionId, binaryKey);
          dispatch(fetchDeleteBinaryKeySuccess());
        } catch (error) {
          dispatch(fetchDeleteBinaryKeyFailed(error));
          dispatch(commonError(error, FETCH_BINARY_KEY_DELETE_FAILURE));
        }
      };
  }

  export const commonError=(error,errorType)=>{
    return({
      type:COMMON_ERROR,
      payload:{
        message:error.message,
        errorType:errorType
      }
    })
  }